import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

const TariffFeatures = lazy(() => import("../layout/tariffFeature/TariffFeatures"));
const AddTariffFeature = lazy(() => import("../layout/tariffFeature/AddTariffFeature"));

function TariffFeaturePage() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Suspense fallback={<div>Loading</div>}>
            <TariffFeatures />
          </Suspense>
        }
      />
      <Route
        path="/add"
        element={
          <Suspense fallback={<div>Loading</div>}>
            <AddTariffFeature />
          </Suspense>
        }
      />
      <Route
        path="/update/:id"
        element={
          <Suspense fallback={<div>Loading</div>}>
            <AddTariffFeature />
          </Suspense>
        }
      />
    </Routes>
  );
}

export default TariffFeaturePage;
